/** @jsx jsx */

import { Fragment as _, useState, useEffect, useRef } from 'react';
import { css, jsx } from '@emotion/core';
import { useSelector, useDispatch } from 'react-redux';
import { State } from 'store/store';
import { killAllAudio } from 'services/killAllAudio';

export const AudioPlayer = () => {
  //
  const audio = useSelector((state: State) => {
    return state.audio;
  });

  const {
    id,
    audioSrc,
    autoPlay = false,
    controls = true,
    delay = 0,
    pause = false,
  } = (audio || {}) as any;

  // const [showAudio, setShowAudio] = useState<boolean>(window.dev() || false);
  // const [playAudio, setPlayAudio] = useState<boolean>(window.dev() || false);

  const audioPlayer = useRef<HTMLAudioElement>(null);
  const delayAudioPlay = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    if (audioSrc && autoPlay) {
      delayAudioPlay.current && clearTimeout(delayAudioPlay.current);
      delayAudioPlay.current = setTimeout(() => {
        //
        // setPlayAudio(true);
        audioPlayer.current && audioPlayer.current.play();
      }, delay * 1000);
      return;
    }

    // setPlayAudio(false);
  }, [audioSrc, autoPlay]);

  useEffect(() => {
    if (!audioPlayer.current) {
      return;
    }

    if (pause) {
      audioPlayer.current.pause();
    }
  }, [pause]);

  useEffect(() => {
    let wait;
    let tick;

    const onFullScreenChange = e => {
      clearInterval(wait);

      if (document.fullscreenElement) {
        tick = setInterval(() => {
          if (!audioPlayer.current) {
            return;
          }

          if (!audioPlayer.current.paused) {
            wait = setTimeout(() => {
              clearInterval(tick);
            }, 3000);

            audioPlayer.current.pause();
          }
        }, 100);
      }
    };

    document.addEventListener('fullscreenchange', onFullScreenChange);

    return () => {
      clearTimeout(wait);
      clearInterval(tick);
      document.removeEventListener('fullscreenchange', onFullScreenChange);
    };
  }, []);

  return audioSrc ? (
    <div
      className="fader_-2s"
      css={css({
        position: 'fixed',
        display: 'flex',
        justifyContent: 'center',
        left: 0,
        bottom: window.dev() ? 40 : 20,
        width: '100%',
        maxWidth: 320,
        height: 35,
        padding: '0 20px',
        zIndex: 100000,

        '@media (max-width: 768px)': {
          maxWidth: '100%',
        },
      })}
    >
      <audio
        ref={audioPlayer}
        src={audioSrc}
        onPlay={() => {
          // setIsPlaying(true);
        }}
        onPause={() => {
          // setIsPlaying(false);
        }}
        css={css({
          width: '100%',
          height: 35,
        })}
        autoPlay={window.dev() ? false : autoPlay}
        controls={window.dev() ? true : controls}
      />
    </div>
  ) : null;
};
